// @ts-check
import { AddIcon, FilterIcon } from '@linearb/linui-common';
import { StyledMissingFiltersActions } from './MissingFiltersActions.style';
import useMissingFiltersActions from './useMissingFiltersActions';
import { LBButton } from '@linearb/buzz';

const MissingFiltersActions = ({ Context }) => {
  const {
    openFilterSetList,
    toggleFilterMenus,
    shouldShowLoadFiltersButton,
    shouldShowAddFiltersButton
  } = useMissingFiltersActions(Context);
  return (
    <StyledMissingFiltersActions>
      {shouldShowAddFiltersButton && (
        <LBButton onClick={toggleFilterMenus}>
          <AddIcon /> Add Filter
        </LBButton>
      )}
      {shouldShowLoadFiltersButton && (
        <LBButton onClick={openFilterSetList}>
          <FilterIcon /> Load Filters
        </LBButton>
      )}
    </StyledMissingFiltersActions>
  );
};

export default MissingFiltersActions;
